import {Routes} from '@angular/router';

export const parkingCashRoutes: Routes = [
  {
    path: 'parking.cash',
    loadComponent: () => import('./parking.cash.component').then(m => m.ParkingCashComponent),
    data: {title: '停车费兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.lottery.cash',
        loadComponent: () => import('./add.lottery.cash/add.lottery.cash.component').then(m => m.AddLotteryCashComponent),
        data: { title: '停车费抽奖兑付明细' },
      },
      {
        path: 'add.lottery.cash/:orderId',
        loadComponent: () => import('./add.lottery.cash/add.lottery.cash.component').then(m => m.AddLotteryCashComponent),
        data: { title: '停车费抽奖兑付明细' },
      },
      {
        path: 'add.equity.cash',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '停车费权益兑付明细' },
      },
      {
        path: 'add.equity.cash/:orderId',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '停车费权益兑付明细' },
      },
    ]
  },
]
